"use client";
import type { Job } from "~/types/job";
import { useJobPageTemplate } from "../registry/registry-provider";
import { UnifiedJobPageTemplate } from "./jobpagetemplate/unified-jobpage-template";

export default function Jobpage({ job }: { job: Job }) {
  const config = useJobPageTemplate(job);

  return <UnifiedJobPageTemplate config={config} job={job} />;
}
